import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const MAX_RECENT = 6

export interface RecentPlace {
  address: string
  name?: string
}

interface RecentPlacesState {
  places: RecentPlace[]
  addPlace: (place: RecentPlace) => void
  clearPlaces: () => void
}

export const useRecentPlacesStore = create<RecentPlacesState>()(
  persist(
    (set, get) => ({
      places: [],

      addPlace: (place) => {
        const trimmed = place.address.trim()
        if (!trimmed) return
        const current = get().places.filter(
          (p) => p.address.trim() !== trimmed,
        )
        set({ places: [place, ...current].slice(0, MAX_RECENT) })
      },

      clearPlaces: () => set({ places: [] }),
    }),
    { name: 'yenko-recent-places' }, // persists to localStorage automatically
  ),
)
